module.exports = __webpack_public_path__ + "img/p2020.336e9df3.png";